import { useSelector } from 'react-redux';

// material-ui
import { useMediaQuery, useTheme } from '@mui/material';

// project import
import NavCard from './NavCard';
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';

// types
import { RootStateProps } from 'types/root';
import { UserProfile } from 'types/auth';

// ==============================|| DRAWER CONTENT ||============================== //

interface DrawerContentProps {
  user: UserProfile
}

const DrawerContent = ({ user }: DrawerContentProps) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

  const menu = useSelector((state: RootStateProps) => state.menu);
  const { drawerOpen } = menu;
  // const env = process.env.REACT_APP_ENV?.toUpperCase();

  const props = { user: user };

  return (
    <SimpleBar
      sx={{
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Navigation {...props} />
      {drawerOpen && !matchDownMD && <NavCard />}
    </SimpleBar>
  );
};

export default DrawerContent;
